/**
 * Utilitaires pour capturer et conserver les paramètres UTM
 */

const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
];

/**
 * Capture les paramètres UTM de l'URL actuelle et les stocke dans sessionStorage
 */
export function captureUtmParams() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const captured = {};
    let hasUtm = false;

    UTM_PARAMS.forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        captured[param] = value;
        hasUtm = true;
      }
    });

    if (hasUtm) {
      // Stocker les nouveaux UTMs capturés
      const existing = getStoredUtmParams();
      const updated = { ...existing, ...captured };
      sessionStorage.setItem('edena_utm_params', JSON.stringify(updated));
    }
  } catch {
    // Silently ignore UTM capture errors
  }
}

/**
 * Récupère les paramètres UTM stockés
 * @returns {Object}
 */
export function getStoredUtmParams() {
  try {
    const stored = sessionStorage.getItem('edena_utm_params');
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

/**
 * Construit un objet de paramètres pour l'URL incluant les UTMs
 * @param {Object} extraParams - Paramètres supplémentaires (ex: reservation_id)
 * @returns {URLSearchParams}
 */
export function buildTrackingParams(extraParams = {}) {
  const utms = getStoredUtmParams();
  const allParams = { ...utms, ...extraParams };
  const params = new URLSearchParams();
  
  Object.entries(allParams).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  
  return params;
}
